/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { EvaluationStatus } from "./evaluationStatus";
import { Log, LogCreated } from "./log";
import { SupportHours } from "./sla";

export type ARAttachedSlas = {
  sla: {
    description: string;
    id: string;
    name: string;
    range: { min: string; max: string; default: string; unit: string } | null;
    supportHours: SupportHours;
    slaType: string;
    unitType: string;
    priority: string;
  };
  data: {
    comment: string;
    log: Log;
  } | null;
  effectiveValue: string;
  effectiveSupportHours: SupportHours;
};

export type ARAttachedTool = {
  tool: {
    deprecated: boolean;
    description: string;
    id: string;
    internal: boolean;
    name: string;
  };
  log: LogCreated;
};
export type ARAttachedServices = {
  attachedSlas: ARAttachedSlas[];
  attachedTools: ARAttachedTool[] | null;
  service: {
    deactivated: boolean;
    id: string;
    name: string;
    version: string;
    pricingType: string;
    serviceGroup: {
      id: string;
      name: string;
    } | null;
  };
};

type AssignmentRuleMain = {
  attachedServices: ARAttachedServices[];
  description: string;
  environmentStatus: string;
  evaluationStatus: EvaluationStatus | string;
  environmentTypes: string[];
  id: string;
  name: string;
};

export type AssignmentRule = AssignmentRuleMain & {
  attachedServiceLevel: {
    serviceLevel: {
      capacityBasedFee: {
        defaultPercentage: string;
        maxPercentage: string;
        minPercentage: string;
      };
      id: string;
      index: number;
      name: string;
    };
    capacityBasedFeeType: CapacityBasedFeeTypeEnum;
    capacityBasedPercentageFee: string;
    effectiveCapacityBasedPercentageFee: string;
  };
};

export type AssignmentRuleFlat = AssignmentRuleMain & {
  attachedServiceLevel: {
    capacityBasedFeeType: CapacityBasedFeeTypeEnum;
    serviceLevelId: string;
    capacityBasedPercentageFee: string;
  } | null;
};

export type AssignmentRuleRouteParams = {
  customerId: string;
  assignmentRuleId: string;
};

export enum CapacityBasedFeeTypeEnum {
  INCLUDED_IN_BASE_FEE_TYPE = "INCLUDED_IN_BASE_FEE",
  DEFAULT_TYPE = "DEFAULT",
  CUSTOM_TYPE = "CUSTOM",
}

type CapacityBaseFeeOptions = {
  value: CapacityBasedFeeTypeEnum;
  label: string;
}[];

export const capacityBaseFeeOptions = [
  {
    value: CapacityBasedFeeTypeEnum.INCLUDED_IN_BASE_FEE_TYPE,
    label: "Included In Base Fee",
  },
  {
    value: CapacityBasedFeeTypeEnum.DEFAULT_TYPE,
    label: "Use Default Value",
  },
  {
    value: CapacityBasedFeeTypeEnum.CUSTOM_TYPE,
    label: "Provide Custom Value",
  },
] as CapacityBaseFeeOptions;
